import Product from './Product.jsx';

export default Product;


// WEBPACK FOOTER //
// ./src/components/Product/index.jsx